<div class="container-fluid">
  <div class="row col-md-12 pl-0">
    <div class="col-md-10 page-heading">
      <h4 class="common-bene-class-for-translation">My Forms1</h4>
  </div>
    <div class="border rounded shadow-sm p-3 col-12 bg-white">
      <div class="row mb-4">
        <div class="col-3">
          <h6 class="w-100 common-bene-class-for-translation">Select the Form Type</h6>
          <p-dropdown [options]="formTypeList" class="w-100" 
          (onChange)="updateFormTypeList();"  
          [(ngModel)]="selectedFormType" optionLabel="name" 
          placeholder="Select Form Type"></p-dropdown>
        </div>
      </div>

      <div>      
        <p-table [columns]="colList" class="im-card-table mat-table" 
          [value]="formsList" dataKey="id" *ngIf="formsList?.length > 0">
          <ng-template pTemplate="header" let-columns>
              <tr class="text-uppercase mat-header-row">
                  <th *ngFor="let col of columns" class="headerText common-bene-class-for-translation">
                      {{col.header}}
                  </th>
                  <th class="common-bene-class-for-translation">Action </th>
              </tr>
          </ng-template>
          <ng-template pTemplate="body" let-task let-columns="columns">
              <tr>
                  <td *ngFor="let col of columns">
                      <span>
                          {{task[col.field]}}
                      </span>
                  </td>
                  <td>
                    <a class="link" *ngIf="task.statusCode === 'INITIATED' || task.statusCode === 'SENTBACK'" title="Enter Details" (click)="handleEdit(task);">Enter Details</a>
                    <mat-icon *ngIf="task.statusCode === 'SEC1VERFD' || task.statusCode === 'SEC1COMPLTD'" matTooltip="View Form" class="pl-2"
                    (click)="handleEdit(task);">visibility
                    </mat-icon> 
                    <mat-icon *ngIf="task.statusCode == 'COMPLTD'" matTooltip="View" class="pl-2"
                        (click)="handleView(task);">visibility
                    </mat-icon> 
                  </td>
              </tr>
          </ng-template>

  </p-table>
  <div *ngIf="formsList?.length == 0" class="mt-4 text-center common-bene-class-for-translation">No Data</div>
  <p-paginator [rows]="pageSize" (onPageChange)="paginationEvent($event)" *ngIf="this.formsList?.length > 0"
      [totalRecords]="totalElementCount" [rowsPerPageOptions]="pageSizeOptions" length="totalElementCount">
  </p-paginator>
</div>


</div>


</div>

<p-dialog header="I-9 Form" class="i9dialog"  [(visible)]="displayDialog" 
[modal]="true" [responsive]="false" 
[draggable]="false"
[style]="{width: '1000px',maxWidth: '1000px', minWidth: '600px',minHeight:'500px'}">
    <pdf-viewer (after-load-complete)="onComplete($event)" (on-progress)="onProgress($event)" [src]="pdfSrc" useBrowserLocale="true"></pdf-viewer>
    <div *ngIf="showLoader" class="text-center mt-5 common-bene-class-for-translation"> Loading Content !!!</div>
</p-dialog>
